import { useFormContext, useWatch } from "react-hook-form";

import FormCombobox from "components/BaseForm/fields/FormCombobox";
import FormCountrySelect from "components/BaseForm/fields/FormCountrySelect";
import { useRegionCountry } from "hooks/useRegionCountry";

/**
 * The record's `region_id` and `country`. A country must belong to its
 * region, so changing the region clears a country outside it.
 */
const LocationFields = () => {
  const { getValues, setValue } = useFormContext();
  const regionId = useWatch({ name: "region_id" });
  const { regions, countries, regionRecords } = useRegionCountry({ regionId });

  const handleRegionChange = nextRegionId => {
    const region = regionRecords.find(({ id }) => id === nextRegionId);
    if (!region?.countries.includes(getValues("country"))) {
      setValue("country", null, { shouldDirty: true });
    }
  };

  return (
    <>
      <FormCombobox
        name="region_id"
        label="Region"
        placeholder="Pick a Region"
        options={regions}
        clearable
        onValueChange={handleRegionChange}
      />
      <FormCountrySelect
        name="country"
        label="Country"
        options={countries}
        clearable
        disabled={!regionId}
      />
    </>
  );
};

export default LocationFields;
